<template>
  <Teleport :to="to" defer>
    <div class="pane-content" @click="handlePaneClick">
      <slot />
    </div>
  </Teleport>
</template>

<script setup>

const { to, paneType } = defineProps({
  to: {
    type: String,
    default: '',
  },
  paneType: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['pane-clicked']);

function handlePaneClick(evt) {
  emit('pane-clicked', evt, paneType);
}

</script>

<style lang="scss" scoped>
  .pane-content {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    flex: 1 1 auto;
    min-height: 0;
  }
</style>
